import React from 'react';
import { useFavicon } from '@client/hooks/use-favicon.hook';

/** Applies hostname-specific favicon on every app route. */
export const EnvironmentFavicon: React.FC = () => {
  useFavicon();
  return null;
};
